var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UiCalendarMonth',{attrs:{"date-in-view":_vm.date,"lang":_vm.defaultLang},on:{"date-select":_vm.onDateSelect},scopedSlots:_vm._u([{key:"date",fn:function({ date }){return [_c('DateRangePickerCalendarDate',{attrs:{"date":date,"date-range":_vm.dateRange,"disabled":_vm.isDateDisabled(date)}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }